module.exports = __webpack_public_path__ + "static/img/partnersBanner.bf00b0e7.jpg";